module.exports = __webpack_public_path__ + "img/DSC_0434-2.84e369d1.jpeg";